module.exports = __webpack_public_path__ + "img/fabric-slide.45749927.jpg";